import SettingsContent from '../Wrapper.vue';
import AgentHome from './Index.vue';
import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/agents'),
      component: SettingsContent,
      props: {
        headerTitle: 'AGENT_MGMT.HEADER',
        icon: 'people',
        showNewButton: false,
        headerActionButtonText: 'AGENT_MGMT.SYNC_PROFILE_PICTURES.BUTTON',
        actionButtonRoutes: ['agent_list'],
        headerActionEvent: 'agents-sync-profile-pictures',
      },
      children: [
        {
          path: '',
          name: 'agents_wrapper',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'agent_list',
          component: AgentHome,
          roles: ['administrator'],
        },
      ],
    },
  ],
};
